import { AppException } from './AppException';

export class OtherExpection extends AppException {
  public readonly name: string;
  public readonly methodName: string;

  constructor(name: string, methodName: string, err: Error, data: unknown, sendToSentry = true) {
    super(err, data, sendToSentry);
    this.name = name;
    this.methodName = methodName;
  }

  override get extras(): any {
    return {
      type: 'Others',
      name: this.name,
      methodName: this.methodName,
    };
  }

  static from(
    name: string,
    methodName: string,
    err: unknown,
    data: unknown,
    sendToSentry = true,
  ): OtherExpection {
    return new OtherExpection(name, methodName, err as Error, data, sendToSentry);
  }
}
